import {stage} from '../stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        endpoint: string;
        region: string;
    };
};

// FNP-1508: test and prod call the flexi-email-api deployed in the EMAIL accounts.
//
// Each endpoint was read from `appsync list-graphql-apis` in its OWN account. An
// AppSync endpoint host is not the api id and cannot be derived from one, so these
// are never constructed from another stage's URL.
//
// dev and ide still point at shared-services on purpose: the API's managed pipeline
// has test and prod stages only, so no AppSync API exists in flexi-email-dev at all.
// Pointing dev at an endpoint that does not exist would break local development.
const appsync: ConfigShape = {
    // flexi-email-prod 803647806861
    prod: {
        endpoint: 'https://y2bp34x2krgidpyy5r7nqfqalq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    // flexi-email-test 630707069968
    test: {
        endpoint: 'https://c6d47qp2pnbldhfthy3km43hny.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    dev: {
        endpoint: 'https://migcorzciffoxhqo3qyi72bvey.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    ide: {
        endpoint: 'https://migcorzciffoxhqo3qyi72bvey.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
};

export const appSyncConfig = appsync[stage];
